/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Virustotal detected url item model.
 * @export
 * @interface CRSFVirustotalDetectedURLItem
 */
export interface CRSFVirustotalDetectedURLItem {
    /**
     * 
     * @type {number}
     * @memberof CRSFVirustotalDetectedURLItem
     */
    positives: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFVirustotalDetectedURLItem
     */
    scan_date: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFVirustotalDetectedURLItem
     */
    total: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFVirustotalDetectedURLItem
     */
    url: string;
}

/**
 * Check if a given object implements the CRSFVirustotalDetectedURLItem interface.
 */
export function instanceOfCRSFVirustotalDetectedURLItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "positives" in value;
    isInstance = isInstance && "scan_date" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "url" in value;

    return isInstance;
}

export function CRSFVirustotalDetectedURLItemFromJSON(json: any): CRSFVirustotalDetectedURLItem {
    return CRSFVirustotalDetectedURLItemFromJSONTyped(json, false);
}

export function CRSFVirustotalDetectedURLItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFVirustotalDetectedURLItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'positives': json['positives'],
        'scan_date': json['scan_date'],
        'total': json['total'],
        'url': json['url'],
    };
}

export function CRSFVirustotalDetectedURLItemToJSON(value?: CRSFVirustotalDetectedURLItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'positives': value.positives,
        'scan_date': value.scan_date,
        'total': value.total,
        'url': value.url,
    };
}

